<template>
  <div :style="{ direction: currentLanguage === 'ar' ? 'rtl' : 'ltr', background: '#F6F9FB' }">
    
    <!-- Tool -->
    <div class="pt-5 pb-5">
      <div class="help-header text-center">
        <h1 class="help-title">{{ currentLanguage === 'en' ? 'Replace Colors in an Image Online' : 'استبدال لون في الصورة أونلاين' }}</h1>
      </div>
      <ColorChangerCom />
    </div>

    <!-- ===== Help Section (REUSED) ===== -->
    <section class="help-section">
      <div class="help-header text-center">
        <h2 class="help-title">
          {{ currentLanguage === 'en' ? 'Color Replacement Guide and FAQs' : 'دليل استبدال الألوان والأسئلة الشائعة' }}
        </h2>
        <p class="help-subtitle">
          {{ currentLanguage === 'en'
            ? 'Learn how to use the Color Changer tool'
            : 'تعرف على كيفية استخدام أداة تغيير الألوان' }}
        </p>
      </div>

      <!-- Tabs -->
      <nav class="tabs-nav" role="tablist" :aria-label="currentLanguage === 'en' ? 'Help topics' : 'موضوعات المساعدة'">
        <button type="button" role="tab" id="color-change-faq-tab" aria-controls="color-change-faq-panel" :aria-selected="activeTab === 'faq'" :class="['tab-btn', activeTab === 'faq' && 'active']" @click="activeTab='faq'" @keydown.right.prevent="activeTab='guide'">
          {{ currentLanguage === 'en' ? 'FAQ' : 'الأسئلة الشائعة' }}
        </button>
        <button type="button" role="tab" id="color-change-guide-tab" aria-controls="color-change-guide-panel" :aria-selected="activeTab === 'guide'" :class="['tab-btn', activeTab === 'guide' && 'active']" @click="activeTab='guide'" @keydown.left.prevent="activeTab='faq'">
          {{ currentLanguage === 'en' ? 'Guide' : 'دليل الاستخدام' }}
        </button>
      </nav>

      <!-- FAQ -->
      <div v-show="activeTab === 'faq'" id="color-change-faq-panel" role="tabpanel" aria-labelledby="color-change-faq-tab" class="tab-pane">
        <div
          v-for="(item, i) in currentFaq"
          :key="i"
          class="faq-item"
          :class="{ open: openFaq === i }"
        >
          <div class="faq-question" @click="openFaq = openFaq === i ? null : i">
            {{ item.q }}
            <span class="faq-toggle">{{ openFaq === i ? '−' : '+' }}</span>
          </div>
          <div class="faq-answer">{{ item.a }}</div>
        </div>
      </div>

      <!-- Guide -->
      <div v-show="activeTab === 'guide'" id="color-change-guide-panel" role="tabpanel" aria-labelledby="color-change-guide-tab" class="tab-pane">
        <div class="search-box">
          <input
            type="text"
            v-model="guideSearch"
            :placeholder="currentLanguage === 'en' ? 'Search...' : 'ابحث...'"
          />
        </div>

        <div v-for="(step, i) in filteredSteps" :key="i" class="step-card">
          <h3>{{ i + 1 }}. {{ step.title }}</h3>
          <p>{{ step.desc }}</p>
        </div>

        <p v-if="filteredSteps.length === 0" class="no-results">
          {{ currentLanguage === 'en' ? 'No results found' : 'لا توجد نتائج' }}
        </p>
      </div>
    </section>

  </div>
</template>

<script>
import ColorChangerCom from '@/components/ColorChangerCom.vue'

export default {
  name: 'ColorChanger',
  components: { ColorChangerCom },

  data() {
    return {
      currentLanguage: this.$store.state.currentLanguage,
      activeTab: 'faq',
      openFaq: null,
      guideSearch: '',

      // FAQ
      faqEn: [
        { q: 'Does this tool use AI?', a: 'Yes, it detects dominant colors and replaces them accurately.' },
        { q: 'Will image quality be affected?', a: 'No, we preserve the highest possible quality.' }
      ],
      faqAr: [
        { q: 'هل الأداة تستخدم الذكاء الاصطناعي؟', a: 'نعم، يتم تحديد الألوان واستبدالها بدقة.' },
        { q: 'هل تتأثر جودة الصورة؟', a: 'لا، نحافظ على أعلى جودة ممكنة.' }
      ],

      // Guide
      stepsEn: [
        { title: 'Upload Image', desc: 'Select or drag your image.' },
        { title: 'Pick Color', desc: 'Choose the color you want to change.' },
        { title: 'Download', desc: 'Save the edited image.' }
      ],
      stepsAr: [
        { title: 'رفع الصورة', desc: 'قم باختيار الصورة أو سحبها.' },
        { title: 'اختيار اللون', desc: 'حدد اللون الذي تريد تغييره.' },
        { title: 'تحميل الصورة', desc: 'احفظ الصورة بعد التعديل.' }
      ]
    }
  },

  computed: {
    currentFaq() {
      return this.currentLanguage === 'en' ? this.faqEn : this.faqAr;
    },
    filteredSteps() {
      const steps = this.currentLanguage === 'en' ? this.stepsEn : this.stepsAr;
      if (!this.guideSearch) return steps;
      return steps.filter(s =>
        (s.title + s.desc).toLowerCase().includes(this.guideSearch.toLowerCase())
      );
    }
  },

  watch: {
    '$store.state.currentLanguage'(newLang) {
      this.currentLanguage = newLang;

      const route = newLang === 'en' ? 'color-changer-en' : 'color-changer-ar';
      if (this.$route.name !== route) {
        this.$router.push({ name: route }).catch(()=>{});
      }
    }
  }
}
</script>
<style scoped lang='scss'>
p {
  font-size: 14px;
  color: #716c80;
}

.section-title {
  h2 {
    line-height: 1.4;
    margin-bottom: 0;
    font-size: 36px;
    font-weight: 700;
    color: #262A37;
  }
  p {
    font-size: 21px;
    color: #716c80;
    margin-bottom: 15px;
  }
}

.ad-banner {
  max-width: 100%;
  border-radius: 12px;
}

// ── Help Section ─────────────────────────────────────────────────
.help-section {
  max-width: 900px;
  margin: 30px auto;
  margin-bottom: 0 ;
  padding: 20px;
  font-family: 'Cairo', sans-serif;
}

.help-header {
  margin-bottom: 40px;
}

.help-title {
  font-weight: 800;
  font-size: 2rem;
  color: #1e1b4b;
  margin-bottom: 8px;
}

.help-subtitle {
  color: #64748b;
  font-size: 14px;
}

// ── Tabs ──────────────────────────────────────────────────────────
.tabs-nav {
  display: flex;
  background: white;
  border-radius: 15px;
  overflow: hidden;
  margin-bottom: 25px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.tab-btn {
  flex: 1;
  padding: 18px;
  border: none;
  background: none;
  font-family: 'Cairo', sans-serif;
  font-weight: 700;
  cursor: pointer;
  transition: 0.3s;
  font-size: 1rem;
  color: #64748b;
  border-bottom: 3px solid transparent;

  &.active {
    color: #3a7afe;
    background: #fdfdff;
    border-bottom: 3px solid #3a7afe;
  }
}

.tab-pane {
  animation: fadeIn 0.4s ease;
}

// ── Section Labels ────────────────────────────────────────────────
.section-label {
  font-size: 1rem;
  font-weight: 700;
  color: #3a7afe;
  margin: 25px 0 15px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e2e8f0;

  .label-icon {
    margin-left: 6px;
    margin-right: 6px;
  }
}

// ── FAQ Items ─────────────────────────────────────────────────────
.faq-item {
  background: white;
  border-radius: 15px;
  margin-bottom: 12px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
}

.faq-question {
  padding: 18px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  color: #1e1b4b;
  font-size: 14px;
  transition: color 0.3s;

  .faq-toggle {
    font-size: 20px;
    color: #64748b;
    flex-shrink: 0;
    margin-right: 8px;
    margin-left: 8px;
    line-height: 1;
  }
}

.faq-answer {
  padding: 0 18px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-out, padding 0.3s;
  color: #64748b;
  font-size: 14px;
  line-height: 1.7;
}

.faq-item.open {
  .faq-question {
    color: #3a7afe;
  }
  .faq-answer {
    max-height: 300px;
    padding: 0 18px 18px;
  }
}

// ── Search Box ────────────────────────────────────────────────────
.search-box {
  position: relative;
  margin-bottom: 30px;

  input {
    width: 100%;
    padding: 15px 45px 15px 20px;
    border-radius: 12px;
    border: 2px solid #e2e8f0;
    font-family: 'Cairo', sans-serif;
    font-size: 1rem;
    box-sizing: border-box;
    outline: none;
    transition: 0.3s;
    color: #1e1b4b;

    &:focus {
      border-color: #3a7afe;
      box-shadow: 0 0 10px rgba(99, 102, 241, 0.1);
    }

    &::placeholder {
      color: #94a3b8;
    }
  }

  .search-icon {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 1.1rem;
    pointer-events: none;
  }
}

[dir="rtl"] .search-box {
  input {
    padding: 15px 20px 15px 45px;
  }
  .search-icon {
    right: auto;
    left: 15px;
  }
}

// ── Step Cards ────────────────────────────────────────────────────
.step-card {
  background: white;
  padding: 25px;
  border-radius: 20px;
  margin-bottom: 20px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.02);
  border-right: 5px solid #3a7afe;

  h2 {
    margin-top: 0;
    font-size: 1.2rem;
    color: #3a7afe;
    font-weight: 700;
    margin-bottom: 10px;
  }

  p {
    margin-bottom: 0;
    color: #64748b;
    font-size: 14px;
    line-height: 1.7;
  }
}

[dir="rtl"] .step-card {
  border-right: none;
  border-left: 5px solid #3a7afe;
}

.snippet-placeholder {
  background: #f1f5f9;
  border: 2px dashed #cbd5e1;
  border-radius: 12px;
  padding: 30px;
  text-align: center;
  margin: 15px 0 0;
  color: #94a3b8;
  font-size: 13px;
  display: none;
}

.no-results {
  text-align: center;
  padding: 40px;
  color: #64748b;
  font-size: 14px;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to   { opacity: 1; transform: translateY(0); }
}

@media (max-width: 769px) {
  .help-section { padding: 10px; }
  .tab-btn { padding: 12px; font-size: 0.9rem; }
  .step-card { padding: 15px; }
  .help-title { font-size: 1.5rem; }
}

@media (min-width: 1400px) {
  .container, .container-lg, .container-md,
  .container-sm, .container-xl, .container-xxl {
    max-width: 1140px;
  }
}
</style>
